const TicketingIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
        <path d="M3.60518 13.3139H12.0777C12.4408 13.3139 12.6829 13.0719 12.6829 12.7088V10.288C12.6829 9.92493 12.4408 9.68286 12.0777 9.68286H3.60518C3.24207 9.68286 3 9.92493 3 10.288V12.7088C3 13.0719 3.24207 13.3139 3.60518 13.3139Z" fill="white"/>
        <path d="M0.605179 8.47251H9.07768C9.44079 8.47251 9.68286 8.23043 9.68286 7.86733V5.44661C9.68286 5.0835 9.44079 4.84143 9.07768 4.84143H0.605179C0.242071 4.84143 0 5.0835 0 5.44661V7.86733C0 8.23043 0.242071 8.47251 0.605179 8.47251Z" fill="white"/>
        <path d="M5.60518 3.63107H14.0777C14.4408 3.63107 14.6829 3.389 14.6829 3.02589V0.605179C14.6829 0.242072 14.4408 0 14.0777 0H5.60518C5.24207 0 5 0.242072 5 0.605179V3.02589C5 3.389 5.24207 3.63107 5.60518 3.63107Z" fill="white"/>
        </svg>
    )
}

export default TicketingIcon;